








































































import Vue from 'vue';
import auth from "@/services/auth";

import InvoiceFlowApi from "@/modules/invoiceFlow/services/InvoiceFlowApi";
import * as ActionLogApi from "@/modules/actionLog/services/api";

import FlowHistory from '@/modules/invoiceFlow/models/FlowHistory';
import IncomingInvoiceRemark from '@/modules/invoiceFlow/models/IncomingInvoiceRemark';
import { ActionLog, IncomingInvoiceTimelineDescriptionItem } from '@/modules/actionLog/models';

interface Data {
  flowHistory: FlowHistory[];
  flowRemarks: IncomingInvoiceRemark[];
  actionLogs: ActionLog[];
  filterOptions: object;
  selectedFilter: number;
}

interface Methods {
  isDescriptionString(description: string | IncomingInvoiceTimelineDescriptionItem[]): boolean;
}

interface Computed {
  items: any;
}

interface Props {
  invoiceId: number | null;
}

export default Vue.extend<Data, Methods, Computed, Props>({
  components: {
  },

  props: {
    invoiceId: { type: Number, default: null }
  },

  data() {
    return {
      flowHistory: [],
      flowRemarks: [],
      actionLogs: [],
      filterOptions: [
        { text: 'Teljes történet', value: 1 },
        { text: 'Hozzám tartozó megjegyzések', value: 2 },
        { text: 'Megjegyzések, amiket én rögzítettem', value: 3 },
        { text: 'Bejegyzések, amiket én hoztam létre', value: 4 }
      ],
      selectedFilter: 2,
    };
  },

    async beforeMount() {
    await Promise.all([
      this.flowHistory = (await InvoiceFlowApi.getFlowHistory(this.$props.invoiceId)).map((h) => new FlowHistory(h)),
      this.flowRemarks = (await InvoiceFlowApi.getRemarkHistory(this.$props.invoiceId)).map((r) => new IncomingInvoiceRemark(r)),
      this.actionLogs = (await ActionLogApi.getInvoiceFlowLogs(this.$props.invoiceId)).map((l) => new ActionLog(l)),
    ]);
  },

  methods: {
    isDescriptionString(description: string | IncomingInvoiceTimelineDescriptionItem[]) {
      return typeof description === String.name.toLowerCase();
    },
  },

  computed: {
    items() {
      let allItems;
      switch (this.selectedFilter) {
        case 2:
          allItems = ([...this.flowRemarks]).filter(x => x.relatedUsers.some(y => y.id == auth.userID) || x.relatedUsers?.length == 0);
          break;
        case 3:
          allItems = ([...this.flowRemarks]).filter(x => x.userName.toUpperCase() == auth.userName.toUpperCase());
          break;
        case 4:
          allItems = ([...this.flowHistory, ...this.actionLogs]).filter(x => x.subtitle.toUpperCase() == auth.userName.toUpperCase());
          break;
        default:
          allItems = [...this.flowHistory, ...this.flowRemarks, ...this.actionLogs]
          break;
      }
      return allItems.sort((a, b) =>
        b.timestamp.isAfter(a.timestamp) ? 1 : -1
      );
    },
  },
})
